import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppConfigService } from '@core/index';

@Component({
  selector: 'jb-section-related-content-block-container',
  templateUrl: './section-related-content-block-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionRelatedContentBlockContainerComponent {
  sectionBlockData: any;
  hasImageHeightWidthAttr = false;
  enableLazyLoadImage: boolean;
  placeholderParams: string;

  constructor(private appConfigService: AppConfigService) {
    this.hasImageHeightWidthAttr = this.appConfigService.imageHeightWidthAttr;
    this.enableLazyLoadImage = this.appConfigService.lazyLoadImages;
    this.placeholderParams =
      this.appConfigService.paths[0].placeholderImageParams;
  }
}

export const sectionRelatedContentBlockContainerResolver = (
  registry,
  data,
) => ({
  sectionBlockData: data.sectionRelatedContent[0],
});
